import { render, staticRenderFns } from "./InformationCheckout.vue?vue&type=template&id=74a5cad6&"
import script from "./InformationCheckout.vue?vue&type=script&lang=js&"
export * from "./InformationCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports